<template>
  <div class="dibu">
    <div class="dibuMain">
      <div class="school">
        <div class="sctop">
          <img
            src="https://middle-school-p.oss-cn-beijing.aliyuncs.com/shouye/diLogon.png"
            alt=""
          />
          <div class="scTitle">
            <p>北京市朝阳区燕京实验中学</p>
            <p>BEJING YANJING EXPERIMENTAL HIGH SCHOOL</p>
          </div>
        </div>

        <div class="address">
          <img
            src="https://middle-school-p.oss-cn-beijing.aliyuncs.com/shouye/dizhi.png"
            alt=""
          />
          <span>主校区地址:学校坐落于北京市朝阳区东坝娘娘庙街</span>
        </div>

        <div class="address">
          <img
            src="https://www.yjsyzx.com/images/b5d6c62d-fb49-4384-8573-476c0dcec01b.png"
            alt=""
          />
          <span>学校电话: 010-57530666、 010-57530655</span>
        </div>
      </div>
      <div class="mobile">
        <div class="moTitle">移动端服务</div>
        <img
          src="https://middle-school-p.oss-cn-beijing.aliyuncs.com/shouye/erweima.jpg"
          alt=""
        />
        <p>微信公众号</p>
      </div>
      <div class="banquan">
        <div class="banTitle">版权信息</div>
        <p>版权所有:北京朝阳燕京实验中学</p>
        <p>网站所有资料未经授权请勿转载</p>
        <p>Copyright © 2024 www.yjsyzx.com</p>
        <p>
          <a
            href="https://beian.miit.gov.cn/#/Integrated/index"
            class="routerColor"
            >京ICP备2024091751号-1</a
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "dibu",
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style scoped>

.routerColor{
  color: white;
  
}
.dibu {
  width: 100%;
  height: 307px;
  background: rgb(64, 64, 64);
}
.dibuMain {
  width: 70%;
  height: 100%;
  display: flex;
  justify-content: space-around;
  margin: 0 auto;
}
.school {
  width: 410px;
  margin-top: 50px;
}
.sctop {
  display: flex;
  justify-content: space-between;
}
.sctop img {
  width: 70px;
  height: 70px;
}

.scTitle P:nth-child(1) {
  color: rgb(255, 255, 255);
  font-family: 思源黑体;
  font-size: 24px;
  font-weight: 700;
  line-height: 35px;
  letter-spacing: 0px;
  text-align: left;
}
.scTitle P:nth-child(2) {
  color: rgb(255, 255, 255);
  font-family: 思源黑体;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: left;
}
.address {
  margin-top: 40px;
}
.address img {
  width: 20px;
  height: 20px;
}
.address span {
  color: rgb(255, 255, 255);
  font-family: 思源黑体;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: left;
}
.mobile {
  width: 120px;
}
.moTitle {
  width: 90px;
  color: rgb(255, 255, 255);
  font-family: 思源黑体;
  font-size: 18px;
  font-weight: 500;
  line-height: 26px;
  letter-spacing: 0px;
  text-align: center;
  padding-bottom: 4px;
  border-bottom: 1px solid white;
  margin: 0 auto;
  margin-top: 50px;
}
.mobile img {
  width: 108px;
  height: 108px;
  display: block;
  margin: 20px auto;
}
.mobile p {
  color: rgb(255, 255, 255);
  font-family: 思源黑体;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: center;
}
.banquan {
  width: 310px;
}
.banTitle {
  width: 75px;
  color: rgb(255, 255, 255);
  font-family: 思源黑体;
  font-size: 18px;
  font-weight: 500;
  line-height: 26px;
  letter-spacing: 0px;
  text-align: left;
  padding-bottom: 4px;
  border-bottom: 1px solid white;
  margin-top: 50px;
  margin-bottom: 20px;
}
.banquan p {
  color: rgb(255, 255, 255);
  font-family: 思源黑体;
  font-size: 14px;
  font-weight: 400;
  line-height: 38px;
  letter-spacing: 0px;
  text-align: left;
}

@media screen and (max-width: 450px) {
  .dibu {
    width: 100%;
    height: 150px;
    background: rgb(64, 64, 64);
  }
  .dibuMain {
    width: 95%;
    height: 100%;
    display: flex;
    justify-content: space-around;
    margin: 0 auto;
  }
  .school {
    width: 200px;
    margin-top: 10px;
  }
  .sctop {
    display: flex;
    justify-content: space-between;
  }
  .sctop img {
    width: 30px;
    height: 30px;
  }

  .scTitle P:nth-child(1) {
    color: rgb(255, 255, 255);
    font-family: 思源黑体;
    font-size: 11px;
    font-weight: 700;
    line-height: 15px;
    letter-spacing: 0px;
    text-align: left;
  }
  .scTitle P:nth-child(2) {
    color: rgb(255, 255, 255);
    font-family: 思源黑体;
    font-size: 6px;
    font-weight: 400;
    line-height: 10px;
    letter-spacing: 0px;
    text-align: left;
  }
  .address {
    margin-top: 5px;
  }
  .address img {
    width: 10px;
    height: 10px;
  }
  .address span {
    color: rgb(255, 255, 255);
    font-family: 思源黑体;
    font-size: 8px;
    font-weight: 400;
    line-height: 10px;
    letter-spacing: 0px;
    text-align: left;
  }
  .mobile {
    width: 80px;
    margin-left: 2px;
  }
  .moTitle {
    width: 80px;
    color: rgb(255, 255, 255);
    font-family: 思源黑体;
    font-size: 15px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0px;
    text-align: center;
    padding-bottom: 4px;
    border-bottom: 1px solid white;
    margin: 0 auto;
    margin-top: 10px;
  }
  .mobile img {
    width: 70px;
    height: 70px;
    display: block;
    margin: 5px auto;
  }
  .mobile p {
    color: rgb(255, 255, 255);
    font-family: 思源黑体;
    font-size: 10px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0px;
    text-align: center;
  }
  .banquan {
    width: 120px;
    margin-left: 5px;
  }
  .banTitle {
    width: 75px;
    color: rgb(255, 255, 255);
    font-family: 思源黑体;
    font-size: 15px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0px;
    text-align: left;
    padding-bottom: 4px;
    border-bottom: 1px solid white;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .banquan p {
    color: rgb(255, 255, 255);
    font-family: 思源黑体;
    font-size: 8px;
    font-weight: 400;
    line-height: 10px;
    letter-spacing: 0px;
    text-align: left;
  }
}
</style>
